import { ArrowClockwiseIcon } from "@phosphor-icons/react/dist/csr/ArrowClockwise";
import { ArrowCounterClockwiseIcon } from "@phosphor-icons/react/dist/csr/ArrowCounterClockwise";
import { Button } from "@volca/ui/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@volca/ui/components/ui/tooltip";
import { ToolbarSegment } from "./toolbar-segment";

interface UndoRedoControlsProps {
  canUndo: boolean;
  canRedo: boolean;
  undoLabel?: string | null;
  redoLabel?: string | null;
  isApplying: boolean;
  onUndo: () => void;
  onRedo: () => void;
}

export const UndoRedoControls = ({
  canUndo,
  canRedo,
  undoLabel,
  redoLabel,
  isApplying,
  onUndo,
  onRedo,
}: UndoRedoControlsProps) => (
  <ToolbarSegment>
    <TooltipProvider delay={200}>
      <Tooltip>
        <TooltipTrigger
          render={
            <Button
              variant="ghost"
              size="icon-sm"
              data-testid="workbook-undo"
              onClick={onUndo}
              disabled={!canUndo || isApplying}
              aria-label={undoLabel ?? "Undo"}
            />
          }
        >
          <ArrowCounterClockwiseIcon />
        </TooltipTrigger>
        <TooltipContent side="bottom">
          {undoLabel ?? "Nothing to undo"}
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger
          render={
            <Button
              variant="ghost"
              size="icon-sm"
              data-testid="workbook-redo"
              onClick={onRedo}
              disabled={!canRedo || isApplying}
              aria-label={redoLabel ?? "Redo"}
            />
          }
        >
          <ArrowClockwiseIcon />
        </TooltipTrigger>
        <TooltipContent side="bottom">
          {redoLabel ?? "Nothing to redo"}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </ToolbarSegment>
);
